import { KYMW1600Model } from '../kymw1600.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像ファイルURL取得要求サービス
 *
 * @export GetImageFileUrlService
 * @class GetImageFileUrlService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetImageFileUrlService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof GetImageFileUrlService
   */
  private model: KYMW1600Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof GetImageFileUrlService
   */
  private vo: {
    extension: string,		// 1:epsのみ、2:pngのみ、3:両方
    imageIdList: string		// 画像IDリスト（、区切り）
  };

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetImageFileUrlService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        Extension: this.vo.extension,
        ImageIdList: this.vo.imageIdList
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @memberof GetImageFileUrlService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1600Model> model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW16GetImageFileUrl', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageFileUrlService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
